import React,{useState, useEffect} from 'react'
import { checkEmptyObj } from '../../../../services/checkEmptyObj';
import { createAdvertiser } from '../../../../services/createAdvertiser';
import './CreateAdvertiser.css';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
import ReactJsAlert from "reactjs-alert"
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getAdvertiserCategories } from '../../../../services/getAdvertisementCategories';
import { createAdvertiserCategory } from '../../../../services/createAdvertiserCategory';
import { deleteAdvertiserCategory } from '../../../../services/deleteAdvertiserCategory';


export default function CreateAdvertiser() {
  const [advertiserData, setAdvertiserData] = useState({ fname: "", lname: "", email: "",companyName:"", password:"", categoryId:"", slotCost:""})
  const token = useSelector(getToken)
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [errorCode, setErrorCode] = useState("");
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [slotCostError, setSlotCostError] = useState("");

  function getAllCategories() {
    getAdvertiserCategories(token).then(result => {
      let options = [];
      result.data.categories.forEach(category => {
        options.push({label: category.CategoryName, value: category.CategoryId});
      });
      setAllCategories(options);
    }).catch(e => {
      console.log(e)
      setAllCategories([]);
    })
  }

  function onAddCategory() {
    const name = window.prompt('New category name');
    if (!name || name.trim() === '') return;
    createAdvertiserCategory(name.trim(), token).then(r => {
      // refresh and preselect
      getAdvertiserCategories(token).then(result => {
        let options = [];
        result.data.categories.forEach(category => {
          options.push({label: category.CategoryName, value: category.CategoryId});
        });
        setAllCategories(options);
        const createdId = r.data && r.data.categoryId ? parseInt(r.data.categoryId, 10) : null;
        if (createdId) {
          const sel = options.find(o => parseInt(o.value,10) === parseInt(createdId,10));
          if (sel) {
            setSelectedCategory(sel);
            setAdvertiserData({ ...advertiserData, categoryId: sel.value });
          }
        }
      });
    }).catch(err => {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setError(true);
        setErrorCode(err.response.data.message);
      } else {
        setError(true);
        setErrorCode('Failed to create category');
      }
    })
  }

  function onDeleteCategory() {
    if (!selectedCategory) {
      setError(true);
      setErrorCode('Select a category to delete');
      return;
    }
    if (!window.confirm(`Delete category '${selectedCategory.label}'? This cannot be undone if in use.`)) return;
    deleteAdvertiserCategory(selectedCategory.value, token).then(() => {
      // refresh
      getAllCategories();
      setSelectedCategory(null);
      setAdvertiserData({ ...advertiserData, categoryId: "" });
    }).catch(err => {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setError(true);
        setErrorCode(err.response.data.message);
      } else {
        setError(true);
        setErrorCode('Failed to delete category');
      }
    })
  }

  function handleCategoryChange(selectedOption) {
    setSelectedCategory(selectedOption);
    if (selectedOption) {
      setAdvertiserData({ ...advertiserData, categoryId: selectedOption.value });
    } else {
      setAdvertiserData({ ...advertiserData, categoryId: "" });
    }
  }

  function onChange(propertyName, newValue) {
    setAdvertiserData({ ...advertiserData, [propertyName]: newValue });
  }

  useEffect(() => {
    getAllCategories();
  }, []);

  function onSubmit(event) {
    event.preventDefault();
    setSlotCostError("");
    
    // Validate slotCost
    if (advertiserData.slotCost === "") {
      setError(true);
      setErrorCode("Slot Cost is required");
      return;
    }
    
    const slotCostNum = parseFloat(advertiserData.slotCost);
    if (isNaN(slotCostNum) || slotCostNum < 0) {
      setSlotCostError("Slot Cost must be a valid number greater than or equal to 0");
      setError(true);
      setErrorCode("Invalid Slot Cost value");
      return;
    }
    
    if (checkEmptyObj(advertiserData)) {
      setError(true);
      return;
    }
    else {
      createAdvertiser(advertiserData, token).then(result => {
        navigate("/adminDashboard/advertisers/home");

      }).catch(e => {
        setError(true);
        setErrorCode(e.message)
      })
    }
  }
  return (
    <div>
      <ReactJsAlert
        status={error} // true or false
        type={"error"} // success, warning, error, info
        title={"There was an error submitting your form"}
        quotes={true}
        quote={errorCode}
        Close={() => setError(false)}
        color="#1E1E1E"
      
      />
      <span className='registeredScreensTitle advertiserListTitle'>Register an Advertiser</span>
      <form onSubmit={onSubmit} className='advertiserRegisterContainer'>
        <div className='advertiserRegisterItemfull'>
          <span className='advertiserRegisterItemTitle'>Advertiser Full Company Name</span>
          <input required max={50} onChange={(e) => { onChange("companyName", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='Advertiser Full Company Name' type={"text"}/>
        </div>
        <div className='advertiserRegisterItemfull'>
          <span className='advertiserRegisterItemTitle'>Category</span>
          <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
            <div style={{flex: 1}}>
              <Select value={selectedCategory} onChange={handleCategoryChange} required isMulti={false} options={allCategories} placeholder='Select Category' />
            </div>
            <button type="button" className='advertiserSmallBtn' onClick={onAddCategory}>+ Add</button>
            <button type="button" className='advertiserSmallBtn danger' onClick={onDeleteCategory}>Delete</button>
          </div>
        </div>
        <div className='advertiserRegisterItemhalfright'>
          <span className='advertiserRegisterItemTitle'>First Name</span>
          <input required max={50} onChange={(e) => { onChange("fname", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='First Name' type={"text"} />
        </div>
        <div className='advertiserRegisterItemhalfleft'>
          <span className='advertiserRegisterItemTitle'>Last Name</span>
          <input required max={50} onChange={(e) => { onChange("lname", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='Last Name' type={"text"} />
        </div>
        <div className='advertiserRegisterItemhalfright'>
          <span className='advertiserRegisterItemTitle'>Email</span>
          <input required max={100} onChange={(e) => { onChange("email", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='Email' type={"email"} />
        </div>
        <div className='advertiserRegisterItemhalfleft'>
          <span className='advertiserRegisterItemTitle'>Password</span>
          <input required max={50} onChange={(e) => { onChange("password", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='Password' type={"password"} />
        </div>
        <div className='advertiserRegisterItemhalfright'>
          <span className='advertiserRegisterItemTitle'>Slot Cost</span>
          <input required min={0} step="0.01" onChange={(e) => { onChange("slotCost", e.nativeEvent.target.value) }} className='advertiserRegisterItemInput' placeholder='0.00' type={"number"} />
          {slotCostError && <span className='advertiserFormFieldError'>{slotCostError}</span>}
        </div>
        <input  type={"submit"} className='advertiserRegisterSubmitBtn' value='Create Advertiser'/>
      </form>
    </div>
  )
}
